import React from 'react';
import Spinner from 'components/loader/Spinner';
import usePipelineCreds from '../hooks/usePipelineCreds';
import { NDialog } from '@innersource-nn/novoui-react';
import CredentialsContainer from 'components/modal/CredentialsModal/CredentialsContainer';

interface CredentialsModalProps {
    open: boolean;
    onClose: () => void;
    region: string;
    repo: string;
}
const CredentialsModal = ({
    open,
    onClose,
    region,
    repo,
}: CredentialsModalProps) => {
    const { script, copyCredentials, loading } = usePipelineCreds(onClose);

    return (
        <NDialog
            isVisible={open}
            headline="Credentials"
            backgroundClose
            closeDialog={onClose}
            size="large"
            showDividers={false}
        >
            {loading ? (
                <div className="flex justify-center items-center mt-52">
                    <Spinner />
                </div>
            ) : (
                <div className="text-true-blue">
                    <CredentialsContainer
                        title="1. Install the `git-remote-codecommit` package using pip:"
                        value="pip install git-remote-codecommit"
                        credentials={[
                            {
                                value: 'pip install git-remote-codecommit',
                                key: 'pip install git-remote-codecommit',
                                simpleValue: true,
                            },
                        ]}
                    />
                    <CredentialsContainer
                        title="2. Verify the Installation: Check that `git-remote-codecommit` is installed correctly by running `git remote-codecommit` in your terminal.It should not return an error."
                        value="git remote-codecommit"
                        credentials={[
                            {
                                value: 'git remote-codecommit',
                                key: 'git remote-codecommit',
                                simpleValue: true,
                            },
                        ]}
                    />
                    <CredentialsContainer
                        title="3. Configure Your Credentials: Paste the following export statements into the terminal"
                        value={copyCredentials[0]}
                        credentials={script}
                        exportCredentials={true}
                    />
                    <CredentialsContainer
                        title="4. Clone the Repository. Paste the clone command into the terminal:"
                        value={`git clone codecommit::${region}:${'//'}${repo}`}
                        credentials={[
                            {
                                value: `git clone codecommit::${region}:${'//'}${repo}`,
                                key: `git clone codecommit::${region}:${'//'}${repo}`,
                                simpleValue: true,
                            },
                        ]}
                    />
                </div>
            )}
        </NDialog>
    );
};
export default CredentialsModal;
